import { render } from "./Offer40offHome.vue?vue&type=template&id=be87e488&scoped=true"
import script from "./Offer40offHome.vue?vue&type=script&lang=js"
export * from "./Offer40offHome.vue?vue&type=script&lang=js"

import "./Offer40offHome.vue?vue&type=style&index=0&id=be87e488&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be87e488"],['__file',"src/views/pre/Offer40offHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be87e488"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be87e488', __exports__)) {
    console.log('reload')
    api.reload('be87e488', __exports__)
  }
  
  module.hot.accept("./Offer40offHome.vue?vue&type=template&id=be87e488&scoped=true", () => {
    console.log('re-render')
    api.rerender('be87e488', render)
  })

}


export default __exports__